module.exports = {

    "名称": "Name",
    "价格": "Price",
    "今日涨跌幅": "Up And Down Today",
    "提示": "Tips",
    "功能正在开发，敬请期待！": "Function Is Under Development, Please Look Forward To It!",
    "关闭": "Close",
    "请先登录": "Please Log In First",
    "无": "Nothing",
    "首页": "Home",
    "行情": "Markets",
    "资讯": "Real-time Info",
    "我的": "My",
    "上拉刷新": "Pull Up To Refresh",
    "释放更新": "Release Updates",
    "加载中": "Loading",
    "意见反馈": "Feedback",
    "语言切换": "Language",
	"在线客服": "Service",
    "安全退出": "Exit",
    "推广码": "Extension Code",
    "交易记录": "record",
    "修改登录密码": "Modify login password",
    "修改支付密码": "Change payment password",
    "实名认证": "Certification",
    "出金": "Withdraw",
    "入金": "Recharge",
    "转账": "Transfer Accounts",
    "持仓盈利": "Position Profit",
    "资产": "Assets",
    "手机": "Mobile Phone",
    "英文": "English",
    "中文简体": "Chinese",
    "最低": "M",
    "最高": "H",
    "买盘": "Bid",
    "卖盘": "Offer",
    "交易": "Transaction",
    "更多": "More",
    "请选择购买类型": "Please Select Purchase Type",
    "市价": "Market Price",
    "取消": "Cancel",
    "对手价": "Rival Price",
    "委托价": "Commission Price",
    "同意": "Agree!",
    "请输入": "Please Enter ",
    "买涨": "Buying Up",
    "买跌": "Buy Down",
    "平仓": "Close Position",
    "分时": "Time Sharing",
    "分": "M",
    "时": "H",
    "日": "Day",
    "周": "Week",
    "月": "Month",
    "你确定吗": "Are You Sure?",
    "弹出说明文本": "Pop Up Description Text",
    "委托价不能低于": "Commission Price Cannot Be Lower Than",
    "手": "Hand",
    "确定交易": "Confirm The Transaction",
    "新": "New",
    "卖": "Sell",
    "买": "Buy",
    "持仓": "Position",
    "挂单": "List",
    "成交": "Deal",
    "合约名称": "Contract Name",
    "手续费": "Service Charge",
    "多空": "Multi Space",
    "总仓": "General Warehouse",
    "可用": "Available",
    "开仓均价": "Average Opening Price",
    "浮盈": "Floating Surplus",
    "操作": "Operation",
    "空": "Empty",
    "多": "Many",
    "开平": "Kaiping",
    "买开": "Buy It",
    "撤单": "Cancel The Order",
    "成交价": "Transaction Price",
    "成交量": "Volume",
    "成交时间": "Transaction Time",
    "卖开": "Sell It",
    "排队价": "Queuing Price",
    "最新价": "Latest Price",
    "超价": "Overpriced",
    "token值错误！": "Token Value Error!",
    "买入": "Purchase",
    "卖出": "Sell Out",
    "确定要撤单": "Are You Sure You Want To Cancel The Order",
    "确定要手动平仓": "Make Sure To Close The Position Manually",
    "登录": "Sign In",
    "部分信息未填写": "Some Information Is Not Filled In",
    "短信验证": "SMS Verification",
    "找回密码": "Retrieve Password",
    "忘记密码": "Forget The Password",
    "暂无数据": "No Data Available",
    "账户列表": "Account List",
    "立即登录": "Log In Now",
    "是否记住密码": "Do You Remember The Password",
    "登录密码": "Login Password",
    "密码": "Password",
    "客户号": "Customer Number",
    "账号": "Account Number",
    "两组密码不相同": "The Two Sets Of Passwords Are Not The Same",
    "手机号": "Cell-phone Number",
    "确认": "Confirm",
    "确认新登录密码": "Confirm New Login Password",
    "设置新登录密码": "Set New Login Password",
    "获取验证码": "Get Captcha",
    "验证码": "Verification Code",
    "登录成功": "Login Successful",
    "短信登录": "SMS Login",
    "加载失败": "Loading Failed",
    "加载完成": "Loading Complete",
    "数据加载中": "Data Loading",
    "发送内容不能为空": "Send Content Cannot Be Empty",
    "上拉加载更多": "Pull Up To Load More",
    "提交": "Submit",
    "内容": "Content",
    "状态": "State",
    "待审核": "To Be Reviewed",
    "审核通过": "Approved",
    "审核拒绝": "Audit Rejection",
    "说明": "Explain",
    "姓名": "Full Name",
    "身份证编号": "ID Card No",
	"原支付密码": "Original Payment Password",
    "确认新支付密码": "Confirm New Payment Password",
    "新支付密码": "New Payment Password",
    "原登录密码": "Original Login Password",
    "买卖": "Business",
    "手数": "Hand Count",
    "平仓盈亏": "Closing Profit And Loss",
    "查询": "Query",
    "至": "To",
    "注册": "Register",
    "推荐人": "Recommender",
    "设置登录密码": "Set Login Password",
    "确认登录密码": "Confirm Login Password",
    "已阅读并同意": "Read And Agree",
    "风险提示": "Risk Statement",
    "立即开户": "Open An Account Now",
    "邮箱": "Mailbox",
    "只能英文和数字": "Only In English And Numbers",
    "请同意交易协议": "Please Agree To The Deal",
    "提现记录": "Withdrawal Record",
    "提现金额": "Withdrawal Amount",
    "提交时间": "Submission Time",
    "备注": "Remarks",
    "充值金额": "Recharge Amount",
    "充值记录": "Recharge Record",
    "链地址": "Chain Address",
    "支付密码": "Payment Password",
    "重要提示": "Important Tips",
    "币种": "Currency",
    "您的个人多重签名": "Your Personal Multi Signature",
    "入金地址": "Deposit Address",
    "存为图片": "Save As Picture",
    "凭证": "Voucher",
    "成功": "Success",
    "转入": "To Change Into",
    "转出": "Transfer Out",
    "未知": "Unknown",
    "转账记录": "Transfer Records",
    "对方账号": "Account Number Of The Opposite Party",
    "转账金额": "Transfer Amount",
    "复制": "Copy",
    "均价": "AVG",
    "涨幅": "Up",
    "开盘价": "Opening Price",
    "收盘价": "Closing Price",
    "最低价": "Minimum Price",
    "最高价": "Highest Price",
    "K线周期图表": "K-line Period Chart",
    "昵称": "Nickname",
    "邮箱验证": "Email Verification",
    "邮箱登录": "Email Login",
    "我的推广二维码": "My Promotion QR Code",
    "推广": "Share your promotion link with your friends to register, and you can enjoy a high commission of 88USDT for an effective transaction of 500USDT",
    "复制推广链接": "Copy Promotion Link",
    "复制成功": "Copy Succeeded",
    "资产不足": "Insufficient Assets",
    "快捷买币": "Quick Buy Money",
    "轻松购买数字资产": "Easy Purchase Of Digital Assets",
    "约": "About",
    "杠杆倍数": "Leverage Ratio",
    "倍":"Times",
    "请先设置支付密码":"Please Set The Payment Password First",
    "止损":"LOSS",
    "止盈":"WIN",
    "开仓":"Open Position",
    "买平":"Buy Even",
    "卖平":"Sell Flat",
    "时间":"Time",
    "不能小于":"Cannot be less than",
    "当前价":"Current Price",

}



// WEBPACK FOOTER //
// ./src/plugins/lang/en-us.js